export const CommonClasses = {
  rounded: "rounded-xl",
  transition: "transition-all ease-in-out duration-300",
  textPrimary: "text-primary",
  textSecondary: "text-secondary",
  bgWhite: "bg-light",
  bgDark: "bg-dark",
  flexCenter: "flex justify-center items-center",
  flexCol: "flex flex-col",
  borderPrimary: "border border-primary",
  shadow: "shadow-lg",
};

const GlobalStyles = {
  button: `min-w-24 py-2 px-4 flex justify-center text-light dark:text-dark text-xs bg-primary hover:bg-primary/50 ${CommonClasses.rounded} ${CommonClasses.transition}`,
  buttonFull: `w-full py-2 flex justify-center text-light dark:text-dark text-xs bg-primary hover:bg-primary/50 ${CommonClasses.rounded} ${CommonClasses.transition}`,
  buttonAlt: `w-24 py-2 flex justify-center text-xs text-primary hover:bg-primary/50 ${CommonClasses.rounded} ${CommonClasses.transition} ${CommonClasses.borderPrimary}`,
  buttonFullAlt: `w-full py-2 flex justify-center text-xs text-primary hover:bg-primary/50 ${CommonClasses.rounded} ${CommonClasses.transition} ${CommonClasses.borderPrimary}`,
  buttonRound: `w-8 h-8 flex justify-center items-center bg-primary/10 hover:bg-primary/30 text-primary text-sm rounded-full ${CommonClasses.transition}`,
  form: `w-5/6 md:w-1/2 lg:w-1/3 bg-light dark:bg-dark p-6 md:p-10 ${CommonClasses.transition} ${CommonClasses.rounded} flex flex-col gap-5`,
  form2: `w-full md:w-2/3 lg:w-1/2 bg-light dark:bg-dark p-6 md:p-10 ${CommonClasses.transition} ${CommonClasses.rounded} flex flex-col gap-5`,
  input: `w-full px-4 py-1.5 text-sm text-primary ${CommonClasses.transition} ${CommonClasses.rounded} placeholder:text-primary/70 outline-none bg-primary/10 focus-within:pl-5 appearance-none`,
  formLogo: `w-14 h-14`,
  formHeader: `text-xl text-dark dark:text-light capitalize ${CommonClasses.transition}`,
  formLink: `text-xs text-primary hover:text-secondary ${CommonClasses.transition}`,
  seperator: `flex w-full justify-between items-center gap-5`,
  seperator2: `flex w-full justify-between items-center gap-5 py-2 border-b border-primary border-dashed`,
  header: `text-2xl lg:text-3xl text-primary font-bold capitalize ${CommonClasses.transition}`,
  textSecondary: `text-secondary text-sm ${CommonClasses.transition}`,
  background: `bg-light dark:bg-dark ${CommonClasses.transition}`,
  navbarWrapper: `w-full h-16 fixed bg-light dark:bg-dark z-30 ${CommonClasses.transition}`,
  navbarLink: `text-secondary hover:text-primary ${CommonClasses.transition} text-sm font-extralight`,
  navbarLogo: `w-16 h-16`,
  navbarLogoText: `text-primary font-semibold text-sm italic`,
  navbarContainer: `w-full h-full flex px-5 lg:px-10 items-center justify-between`,
  navbarBrand: `flex items-center gap-1`,
  dashbooardPageContainer: `w-full h-screen ${CommonClasses.flexCol} overflow-hidden ${CommonClasses.transition} pt-16 lg:pl-64 bg-default bg-no-repeat bg-center bg-cover z-0`,
  // dashbooardPageContainer: `w-full h-screen ${CommonClasses.flexCol} overflow-hidden ${CommonClasses.transition} pt-16 lg:pl-64 bg-light dark:bg-dark z-0`,
  dashbooardPageWrap: `w-full h-full flex flex-col overflow-scroll ${CommonClasses.flexCol} p-5 lg:p-10 pb-20 gap-5 bg-black/50 backdrop-blur`,
  // dashbooardPageWrap: `w-full h-full flex flex-col overflow-scroll ${CommonClasses.flexCol} p-5 lg:p-10 pb-20 gap-5 bg-secondary/10`,
  breadContainer: `w-fit flex items-center gap-1 lg:gap-2 py-2 px-3 ${CommonClasses.transition} ${CommonClasses.rounded} z-20 bg-light dark:bg-dark`,
  breadLink: `text-xss ${CommonClasses.textPrimary} capitalize font-light hover:text-primary/70 ${CommonClasses.transition}`,
  breadIcon: `${CommonClasses.textPrimary} text-lg lg:text-xl`,
  sectionWrap: `w-full bg-light dark:bg-dark ${CommonClasses.rounded} p-5 lg:p-8 ${CommonClasses.transition} z-20`,
  sectionDivider: "w-full gap-5 flex max-lg:flex-col",
  sectionDividerGridFour:
    "w-full gap-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
  textCount: `text-xs text-light dark:text-dark ${CommonClasses.transition}`,
  searchContainer: `w-full bg-light dark:bg-dark py-2 px-3 flex gap-1 items-center ${CommonClasses.transition} ${CommonClasses.rounded}`,
  searchContainer2: `w-5/6 md:w-2/3 lg:w-1/2 bg-light dark:bg-dark py-2 px-3 flex gap-1 items-center ${CommonClasses.transition} ${CommonClasses.rounded}`,
  searchIcon: `text-sm text-primary ml-2`,
  searchInput: `w-full bg-light dark:bg-dark ${CommonClasses.rounded} ${CommonClasses.transition} placeholder:text-primary/70 outline-none px-3 text-sm text-primary`,
  textOrder: `text-secondary text-xs`,
  serviceCard: `p-5 bg-primary/90 ${CommonClasses.rounded}`,

  serviceIcon: `w-16 h-16 rounded-full flex items-center justify-center mb-4 bg-light dark:bg-dark text-primary ${CommonClasses.transition}`,
  serviceTitle: `text-xl font-semibold mb-2 text-light dark:text-dark ${CommonClasses.transition}`,
  sectionHeader: `text-xl font-bold text-dark dark:text-light ${CommonClasses.transition}`,
  text: `text-light dark:text-dark ${CommonClasses.transition}`,
  headerPrimary: `text-3xl font-semibold text-primary`,
  listItem: `hover:bg-primary/10 ${CommonClasses.transition}`,
  buttonOutline: `border border-primary text-primary hover:bg-primary/10 px-3 py-1 rounded-md ${CommonClasses.transition}`,
};

export default GlobalStyles;
